import { createClassName } from 'utils/createClassName';

import './partnerRegistrationManagerLayoutStyles.scss';

export const createPartnerRegistrationManagerLayotClassName = createClassName(
  'partnerRegistrationManagerLayot'
);
